






import Vue from 'vue'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import CalendarEventEditorEmployeeSelect from '@/components/planning/calendar-event/employee/CalendarEventEditorEmployeeSelect.vue'

export default Vue.extend({
  name: 'CalendarEventEditorEmployee',

  components: {
    CalendarEventEditorEmployeeSelect
  },

  props: {
    editCalendarEvent: Object as () => CalendarEvent | undefined,
  },

})
